import React from "react";
import { useWebSocket } from "../../context/WebSocketContext";
import "./WebSocketStatus.css";

const WebSocketStatus = () => {
  const { connectionStatus, error, reconnect } = useWebSocket();

  const getStatusColor = () => {
    switch (connectionStatus) {
      case "connected":
        return "#4CAF50";
      case "connecting":
        return "#FF9800";
      case "disconnected":
        return "#F44336";
      default:
        return "#9E9E9E";
    }
  };

  return null;
};

export default WebSocketStatus;
